<template>
    <div class="sidebar">
        <el-menu class="sidebar-el-menu" :default-active="onRoutes" :collapse="collapse" background-color="#324157"
                 text-color="#bfcbd9" active-text-color="#20a0ff" unique-opened router>
            <template v-for="item in items">
                <template v-if="item.subs">
                    <el-submenu :index="item.index" :key="item.index">
                        <template slot="title">
                            <i :class="item.icon"></i><span slot="title">{{ item.title }}</span>
                        </template>
                        <template v-for="subItem in item.subs">
                            <el-submenu v-if="subItem.subs" :index="subItem.index" :key="subItem.index">
                                <template slot="title">
                                    <i :class="subItem.icon"></i><span slot="title">{{ subItem.title }}</span>
                                </template>
                                <el-menu-item v-for="(threeItem,i) in subItem.subs" :key="i" :index="threeItem.index">
                                    <i :class="threeItem.icon"></i>{{ threeItem.title }}
                                </el-menu-item>
                            </el-submenu>
                            <el-menu-item v-else :index="subItem.index" :key="subItem.index">
                                <i :class="subItem.icon"></i><span slot="title">{{ subItem.title }}</span>
                            </el-menu-item>
                        </template>
                    </el-submenu>
                </template>
                <template v-else>
                    <el-menu-item :index="item.index" :key="item.index">
                        <i :class="item.icon"></i><span slot="title">{{ item.title }}</span>
                    </el-menu-item>
                </template>
            </template>
        </el-menu>
    </div>
</template>

<script>
    import bus from '../common/bus';
    import {SysMenu} from "../../api/sysMenu";

    export default {
        data() {
            return {
                collapse: false,
                items: [
                    /*{
                        icon: 'el-icon-lx-home',
                        index: 'dashboard',
                        title: '系统首页'
                    },
                    {
                        icon: 'el-icon-lx-settings',
                        index: 'sys-manager',
                        title: '系统管理',
                        subs: [
                            {
                                icon: 'el-icon-lx-profile',
                                index: 'sys-user',
                                title: '系统用户'
                            },
                            {
                                icon: 'el-icon-lx-text',
                                index: 'sys-log',
                                title: '系统日志'
                            }
                        ]
                    }, {
                        icon: 'el-icon-lx-group',
                        index: 'team',
                        title: '团队管理',
                        subs: [
                            {
                                icon: 'el-icon-lx-news',
                                index: 'department',
                                title: '部门列表'
                            },
                            {
                                icon: 'el-icon-lx-friend',
                                index: 'ud-user',
                                title: '成员管理'
                            },
                        ]
                    }, {
                        icon: 'el-icon-lx-addressbook',
                        index: '2',
                        title: '客户管理',
                        subs: [
                            {
                                icon: 'el-icon-lx-service',
                                index: 'sale',
                                title: '销售部',
                                subs: [
                                    {
                                        icon: 'el-icon-lx-rank',
                                        index: 'invite-user',
                                        title: '邀约数据'
                                    },
                                    {
                                        icon: 'el-icon-lx-people',
                                        index: 'invite',
                                        title: '邀约客户'
                                    }
                                ]
                            },
                            {
                                icon: 'el-icon-lx-global',
                                index: 'network',
                                title: '网络部',
                                subs: []
                            },
                            {
                                icon: 'el-icon-lx-group',
                                index: 'design',
                                title: '设计部',
                                subs: []
                            }
                        ]
                    },
                    {
                        icon: 'el-icon-lx-goods',
                        index: 'order',
                        title: '订单管理',
                        subs: [
                            /!*{
                                icon: 'el-icon-lx-people',
                                index: 'customer',
                                title: '订单客户'
                            },*!/
                            {
                                icon: 'el-icon-lx-sort',
                                index: 'order',
                                title: '订单列表'
                            }
                        ]
                    },
                    {
                        icon: 'el-icon-lx-copy',
                        index: 'means',
                        title: '报价管理'
                    }, /!* {
                        icon: 'el-icon-lx-emoji',
                        index: 'icon',
                        title: '图标'
                    },*!/ {
                        icon: 'el-icon-lx-warn',
                        index: '7',
                        title: '错误处理',
                        subs: [
                            {
                                index: 'permission',
                                title: '权限测试'
                            },
                            {
                                index: '404',
                                title: '404页面'
                            }
                        ]
                    }*/
                ]
            }
        },
        computed: {
            onRoutes() {
                return this.$route.path.replace('/', '');
            }
        },
        created() {
            let menus = JSON.parse(localStorage.getItem("menus"));
            // 获取菜单栏
            this.items = this.dataFormat(menus);
            // 通过 Event Bus 进行组件间通信，来折叠侧边栏
            bus.$on('collapse', msg => {
                this.collapse = msg;
            });
        },
        methods: {
            /**
             * 生成菜单格式
             * @param list
             * @returns {Array}
             */
            dataFormat(list) {
                let menus = [];
                let menuList = list;
                for (let i = 0; i < menuList.length; i++) {
                    if (menuList[i].parentId === 1) {
                        let obj = {
                            id: menuList[i].id,
                            icon: menuList[i].icon,
                            index: menuList[i].index,
                            title: menuList[i].name,
                            subs: []
                        };
                        menus.push(obj);
                    }
                }
                for (let i = 0; i < menus.length; i++) {
                    for (let j = 0; j < menuList.length; j++) {
                        if (menuList[j].parentId === menus[i].id) {
                            menus[i].subs.push({
                                id: menuList[j].id,
                                icon: menuList[j].icon,
                                index: menuList[j].index,
                                title: menuList[j].name,
                                subs: []
                            })
                        }
                    }
                    for (let j = 0; j < menus[i].subs.length; j++) {
                        for (let k = 0; k < menuList.length; k++) {
                            if (menuList[k].parentId === menus[i].subs[j].id) {
                                menus[i].subs[j].subs.push({
                                    id: menuList[k].id,
                                    icon: menuList[k].icon,
                                    index: menuList[k].index,
                                    title: menuList[k].name,
                                    subs: []
                                })
                            }
                        }
                        if (menus[i].subs[j].subs.length === 0) {
                            delete menus[i].subs[j].subs;
                        }
                    }
                    if (menus[i].subs.length === 0) {
                        delete menus[i].subs;
                    }
                }
                //console.log(menus);
                return menus;
            }
        }
    }
</script>

<style scoped>
    .sidebar {
        display: block;
        position: absolute;
        left: 0;
        top: 70px;
        bottom: 0;
        overflow-y: scroll;
    }

    .sidebar::-webkit-scrollbar {
        width: 0;
    }

    .sidebar-el-menu:not(.el-menu--collapse) {
        width: 250px;
    }

    .sidebar > ul {
        height: 100%;
    }
</style>
